import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addNote: 'Add a note',
    note: 'Note',
    noteInputPlaceholder: 'Transaction note',
    ok: 'Ok',
  },
  fr: {
    addNote: 'Ajouter une note',
    note: 'Note',
    noteInputPlaceholder: 'Note de la transaction',
    ok: 'Ok',
  },
});

export default locales;
